import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FriendsSurveyStatusComponent } from './friendsSurveyStatus.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SingleFriendStatusModule } from '@app/profile/friendsSurveyStatus/singleFriendStatus/singleFriendStatus.module';
import { LoaderModule } from '@shared/loader/loader.module';

@NgModule({
  imports: [CommonModule, ButtonModule, TranslateModule, PlIconModule, SingleFriendStatusModule, LoaderModule],
  declarations: [FriendsSurveyStatusComponent],
  exports: [FriendsSurveyStatusComponent],
})
export class FriendsSurveyStatusModule {}
